/*
 * Header JS.
 *
 * @type {Object}
 */
const headerHub = {
	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		this.searchButton = document.getElementById( "toggle-header-search" );
		this.searchInput = document.getElementsByClassName(
			"cai2025-search-form__input",
		)[0];

		this.searchCloseButton = document.getElementById( "search-close" );
		this.searchForm = document.getElementById( "header-search-bar" );

		this.header = document.querySelector( ".cai-site-header" );

		this.burgerMenu = document.getElementById(
			"primary-header__menu-button",
		);

		this.mobileMenu = document.getElementById( "site-navigation" );

		this.subMenuIcons = document.querySelectorAll(
			".menu-item-has-children > a",
		);

		// Sticky Bar Element
		this.stickyBar = document.getElementById( "sticky-bar" );

		// Only proceed if required elements exist
		if ( this.header ) {
			this.addEvents();
			this.openChildMenu();
			this.focusPrimaryMenu();
		}
	},

	/**
	 * Add events.
	 *
	 * @return {void}
	 */
	addEvents() {
		if ( null !== this.searchButton ) {
			this.searchButton.addEventListener( "click", () => {
				this.openSearchButton();
			} );
		}

		if ( null !== this.searchCloseButton ) {
			this.searchCloseButton.addEventListener( "click", () =>
				this.closeSearchBar(),
			);
		}

		window.addEventListener( "click", ( event ) => {
			let isClickInsideForm = true;

			if ( null !== this.searchForm && null !== this.searchButton ) {
				isClickInsideForm =
					this.searchForm.contains( event.target ) ||
					this.searchButton.contains( event.target );
			}

			if ( !isClickInsideForm ) {
				this.closeSearchBar();
			}
		} );

		// Scroll events
		window.addEventListener( "scroll", () => {
			if ( this.header ) {
				this.hideTopMenu();
			}
			if ( this.stickyBar ) {
				this.toggleStickyBar();
			}
		} );

		document.addEventListener( "keydown", ( event ) => {
			let isEscape = false;

			if ( "key" in event ) {
				isEscape = "Escape" === event.key || "Esc" === event.key;
			} else {
				isEscape = 27 === event.keyCode;
			}

			if ( isEscape ) {
				this.closeSearchBar();
			}
		} );

		// Burger menu events
		if ( this.burgerMenu && this.mobileMenu ) {
			this.burgerMenu.addEventListener( "click", () =>
				this.moveBurgerMenu(),
			);
		}

		// Close menu on clicking a menu item if it's an anchor link to the same page
		if ( this.mobileMenu ) {
			this.mobileMenu.addEventListener( "click", ( event ) => {
				const link = event.target.closest( "a" );
				if ( !link ) return;

				const href = link.getAttribute( "href" );

				// Check if the link is an anchor link and belongs to the same page
				if ( href && href.startsWith( "#" ) ) {
					this.closeMobileMenu();
				} else {
					// Safely get and sanitize current origin and path
					const getSanitizedLocation = () => {
						const origin = String( window.location.origin ).replace(
							/[^\w\s:/.\\-_]/g,
							"",
						);
						
						// phpcs:ignore WordPressVIPMinimum.JS.Window.location -- window.location.pathname is sanitized before use
						const pathname = String( window.location.pathname ).replace( /[^\w\s./\-_]/g, "" );
						return { origin, pathname };
					};

					const { origin: currentOrigin, pathname: currentPath } =
						getSanitizedLocation();

					let linkUrl;
					try {
						linkUrl = new URL( link.href, currentOrigin );
					} catch ( error ) {
						// If URL construction fails, bail early
						return;
					}

					const sanitizedLinkPath = linkUrl.pathname.replace(
						/[^\w\s./\-_]/g,
						"",
					);

					if (
						linkUrl.origin === currentOrigin &&
						sanitizedLinkPath === currentPath
					) {
						// If it's the same page but has an anchor
						if ( linkUrl.hash ) {
							this.closeMobileMenu();
						}
					}
				}
			} );
		}

		const menuBtn = document.querySelector( ".our-brands-menu-btn" );
		const dropdown = document.querySelector( ".our-brands-dropdown" );

		if ( menuBtn && dropdown ) {
			menuBtn.addEventListener( "click", function ( e ) {
				// Only toggle on mobile
				if ( window.innerWidth <= 768 ) {
					e.preventDefault(); // Prevent any default behavior if needed
					dropdown.classList.toggle( "is-visible" );
				}
			} );
		}

		document.addEventListener( "click", function ( e ) {
			const menuBtn = document.querySelector( ".our-brands-menu-btn" );
			const dropdown = document.querySelector( ".our-brands-dropdown" );

			if (
				dropdown.classList.contains( "is-visible" ) &&
				!dropdown.contains( e.target ) &&
				!menuBtn.contains( e.target )
			) {
				dropdown.classList.remove( "is-visible" );
			}
		} );

		document.addEventListener( "focusout", function ( event ) {
			setTimeout( () => {
				const menu = document.querySelector( ".cai-primary-menu" ); // or your menu class
				if ( menu && !menu.contains( document.activeElement ) ) {
					// Remove focus classes to collapse submenus if added by CSS
					menu.querySelectorAll( ".menu-item.focus" ).forEach( ( el ) =>
						el.classList.remove( "focus" ),
					);
				}
			}, 10 ); // Allow DOM to update focus
		} );

		// Resize events
		window.addEventListener( "resize", () => {
			if ( window.innerWidth >= 1025 ) {
				this.closeMobileMenu();
			}
		} );
	},

	/**
	 * Open search bar.
	 *
	 * @return {void}
	 */
	openSearchButton() {
		this.closeMobileMenu();
		this.closeInnerMenu();
		this.resetInnerMenu();

		this.searchForm.classList.add( "header-search-bar--active" );
		this.updateScrollLock();

		this.searchInput.value = "";
		setTimeout( () => {
			this.searchInput.focus();
		}, 200 );
	},

	/**
	 * Closes search bar.
	 *
	 * @return {void}
	 */
	closeSearchBar() {
		if ( this.searchForm.classList.contains( "header-search-bar--active" ) ) {
			this.searchButton.focus();
		}

		this.searchForm.classList.remove( "header-search-bar--active" );

		this.updateScrollLock(); // Moved after class removal
	},

	/**
	 * Hides top Menu.
	 *
	 * @return {void}
	 */
	hideTopMenu() {
		if ( !this.header || this.lockedByOverlay ) {
			return;
		}

		if ( window.scrollY >= 100 ) {
			this.header.classList.add( "site-header--is-scrolling" );
		} else {
			this.header.classList.remove( "site-header--is-scrolling" );
		}
	},

	/**
	 * Toggle Sticky Bar visibility.
	 *
	 * @return {void}
	 */
	toggleStickyBar() {
		if ( !this.header || !this.stickyBar ) {
			return;
		}

		const headerHeight = this.header.offsetHeight;

		// Check if the user has scrolled past the header
		if ( window.pageYOffset > headerHeight ) {
			this.stickyBar.classList.add( "show-sticky" ); // Show sticky bar
		} else {
			this.stickyBar.classList.remove( "show-sticky" ); // Hide sticky bar
		}
	},

	/**
	 * Moves Burger Menu.
	 *
	 * @return {void}
	 */

	moveBurgerMenu() {
		this.burgerMenu.classList.toggle( "primary-header__menu-button--close" );
		this.mobileMenu.classList.toggle( "mobile-main-menu--displayed" );
		document.body.classList.toggle( "disable-scroll" );

		this.closeInnerMenu();
		this.resetInnerMenu();
	},

	/**
	 * Remove Burger Menu class to close mobile menu.
	 *
	 * @return {void}
	 */
	closeMobileMenu() {
		if ( !this.burgerMenu || !this.mobileMenu ) {
			return;
		}

		if ( this.mobileMenu.classList.contains( "mobile-main-menu--displayed" ) ) {
			this.burgerMenu.classList.remove(
				"primary-header__menu-button--close",
			);
			this.mobileMenu.classList.remove( "mobile-main-menu--displayed" );
			this.updateScrollLock();
		}
	},

	/**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing.
	 *
	 * @param {Function} func The function to debounce.
	 * @param {Number} delay The number of milliseconds to delay.
	 * @returns {Function} The debounced function.
	 */
	debounce( func, delay ) {
		let timer;
		return function () {
			const context = this;
			const args = arguments;
			clearTimeout( timer );
			timer = setTimeout( () => {
				func.apply( context, args );
			}, delay );
		};
	},

	/**
	 * Highlight menu on keyboard navigation.
	 *
	 * @return {boolean|void} Toggle focus class on keyboard navigation.
	 */
	focusPrimaryMenu() {
		const menu = document.querySelector( ".main-navigation" );
		if ( !menu ) {
			return false;
		}

		const links = menu.getElementsByTagName( "a" );
		if ( !links.length ) {
			return false;
		}

		for ( let i = 0; i < links.length; i++ ) {
			links[i].addEventListener( "focus", toggleFocus, true );
			links[i].addEventListener( "blur", toggleFocus, true );
			if ( links[i].parentElement ) {
				links[i].parentElement.addEventListener(
					"mouseenter",
					removeFocusClassOnHover,
				);
				links[i].parentElement.addEventListener(
					"mouseleave",
					removeFocusClassOnHover,
				);
			}
		}

		/**
		 * Toggles the 'focus' class on menu items when they are focused or blurred,
		 * ensuring only one item has the class at any time.
		 *
		 * This function traverses up the DOM tree from the current element, checking
		 * each ancestor until it reaches an element with the 'hub-primary-menu' class.
		 * If an ancestor is a list item ('li'), it toggles the 'focus' class on it.
		 */
		function toggleFocus() {
			let self = this;

			// Remove the focus class from all menu items.
			removeFocusClassFromAll();

			while ( self && self.className.indexOf( "hub-primary-menu" ) === -1 ) {
				if ( self.tagName.toLowerCase() === "li" ) {
					if ( self.className.indexOf( "focus" ) !== -1 ) {
						self.className = self.className.replace( " focus", "" );
					} else {
						self.className += " focus";
					}
				}
				self = self.parentElement;
			}
		}

		/**
		 * Removes the 'focus' class from all menu items when the user hovers
		 * over a different menu item.
		 *
		 * This function traverses up the DOM tree from the current element,
		 * checking each ancestor until it reaches an element with the
		 * 'hub-primary-menu' class. If an ancestor is a list item ('li'), it
		 * removes the 'focus' class from it.
		 */
		function removeFocusClassOnHover() {
			let self = this;

			while ( self && self.className.indexOf( "hub-primary-menu" ) === -1 ) {
				if ( self.tagName.toLowerCase() === "li" ) {
					self.className = self.className.replace( " focus", "" );
				}
				self = self.parentElement;
			}
		}

		/**
		 * Removes the 'focus' class from all menu items.
		 *
		 * This function uses `querySelectorAll` to find all elements with the
		 * 'focus' class, and then iterates over them, removing the class from
		 * any elements that have it. This is used to ensure that only one
		 * element has the class at any time.
		 */
		function removeFocusClassFromAll() {
			const focusedItems = menu.querySelectorAll( ".focus" );
			focusedItems.forEach( ( item ) => {
				if ( item && item.className ) {
					item.className = item.className.replace( " focus", "" );
				}
			} );
		}
	},

	/**
	 * Close inner child menu on mobile.
	 *
	 * @return {void}
	 */
	closeInnerMenu() {
		setTimeout( () => {
			if ( null !== document.querySelector( ".sub-menu--active" ) ) {
				document
					.querySelectorAll( ".sub-menu--active" )
					.forEach( ( subMenu ) => {
						subMenu.classList.remove( "sub-menu--active" );
					} );
			}

			if (
				null !==
				document.querySelector( ".mobile-main-menu__toggle--close" )
			) {
				document
					.querySelectorAll( ".mobile-main-menu__toggle--close" )
					.forEach( ( subMenu ) => {
						subMenu.classList.remove(
							"mobile-main-menu__toggle--close",
						);
					} );
			}
		}, 200 );
	},

	/**
	 * Reset inner menu item classes.
	 *
	 * @return {void}
	 */
	resetInnerMenu() {
		setTimeout( () => {
			if (
				null !== document.querySelector( ".primary-menu" ) &&
				document
					.querySelector( ".primary-menu" )
					.classList.contains( "oh-active" )
			) {
				document
					.querySelector( ".primary-menu" )
					.classList.remove( "oh-active" );
			}

			if ( null !== document.querySelector( ".primary-menu .sub-menu" ) ) {
				document
					.querySelectorAll( ".primary-menu .sub-menu" )
					.forEach( ( subMenu ) => {
						if ( subMenu.classList.contains( "active" ) ) {
							subMenu.classList.remove( "active" );
						}

						if ( subMenu.classList.contains( "oh-active" ) ) {
							subMenu.classList.remove( "oh-active" );
						}
					} );
			}

			if ( null !== document.querySelector( ".oh-active" ) ) {
				document
					.querySelectorAll( ".oh-active" )
					.forEach( function ( link ) {
						link.classList.remove( "oh-active" );
					} );
			}
		}, 200 );
	},

	/**
	 * Open sub menu.
	 *
	 * @return {void}
	 */

	openChildMenu() {
		const menuWrap = document.getElementById( "cai-primary-menu" );

		if ( !menuWrap ) return;

		menuWrap.addEventListener(
			"click",
			this.debounce( this.handleSubMenuClick.bind( this ), 200 ),
		);
	},

	/**
	 * Handle submenu click.
	 *
	 * @param {Object} event The click event object.
	 *
	 * @return {void}
	 */

	handleSubMenuClick( event ) {
		if ( window.innerWidth >= 1025 ) return;

		const icon = event.target.closest( ".has-child-menu-icon" );
		if ( !icon ) return;

		event.preventDefault();

		const parent = icon.closest( ".menu-item-has-children" );
		if ( !parent ) return;

		const submenu = parent.querySelector( ".sub-menu" );
		if ( !submenu ) return;

		const isOpen = parent.classList.contains( "oh-active" );

		// Close all others
		document
			.querySelectorAll( ".menu-item-has-children.oh-active" )
			.forEach( ( item ) => {
				if ( item !== parent ) {
					item.classList.remove( "oh-active" );
					const sub = item.querySelector( ".sub-menu" );
					if ( sub ) {
						sub.style.maxHeight = null;
					}
				}
			} );

		// Toggle current
		if ( isOpen ) {
			parent.classList.remove( "oh-active" );
			submenu.style.maxHeight = null;
		} else {
			parent.classList.add( "oh-active" );
			submenu.style.maxHeight = submenu.scrollHeight + "px";
		}
	},

	/**
	 * Toggles scroll locking based on the visibility of the search bar or mobile menu.
	 *
	 * - If either the search bar (`header-search-bar--active`) or mobile menu (`mobile-main-menu--displayed`) is open,
	 * it locks the scroll by adding the `disable-scroll` class to both `<html>` and `<body>`.
	 * - It also stores the current scroll position to restore later when unlocking scroll.
	 * - If neither is open, it removes the scroll lock and scrolls back to the original position.
	 *
	 * @return {void}
	 */
	updateScrollLock() {
		this.lockedByOverlay = false;

		const isSearchOpen = this.searchForm.classList.contains(
			"header-search-bar--active",
		);
		const isMenuOpen = this.mobileMenu.classList.contains(
			"mobile-main-menu--displayed",
		);

		this.lockedByOverlay = isSearchOpen || isMenuOpen;

		if ( this.lockedByOverlay ) {
			this.scrollPosition =
				window.scrollY || document.documentElement.scrollTop;
			document.documentElement.classList.add( "disable-scroll" );
			document.body.classList.add( "disable-scroll" );
		} else {
			document.body.classList.remove( "disable-scroll" );
			document.documentElement.classList.remove( "disable-scroll" );

			// Don't scroll if user never scrolled before opening
			if ( this.scrollPosition > 0 ) {
				window.scrollTo( 0, this.scrollPosition );
			}
		}
	},
};

export default headerHub;
